import { render, staticRenderFns } from "./CardIncidentsTable.vue?vue&type=template&id=3675849c&"
import script from "./CardIncidentsTable.vue?vue&type=script&lang=js&"
export * from "./CardIncidentsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports